import { createFileRoute } from '@tanstack/react-router';
import { CommunicationDetailsPage } from '~/pages/admin/communication-details-page';

export const Route = createFileRoute('/admin/communications/$id')({
  component: CommunicationDetailsPage,
});

